import { css } from 'styled-components';
import { mediaQuery } from 'src/app/styles/helper';

export type ColumnSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export const getColumnSpan = (span?: ColumnSpan): string => {
  if (span) {
    return `span ${span} / span ${span}`;
  }
  return `span calc(var(--grid-total-columns, 12) / var(--grid-total-children, 1))`;
};

export interface ColumnProps {
  columns?: ColumnSpan;
  columnsSm?: ColumnSpan;
  columnsMd?: ColumnSpan;
  columnsLg?: ColumnSpan;
  columnsXl?: ColumnSpan;
  columns2xl?: ColumnSpan;
}

export type StyledColumnProps = {
  [K in keyof ColumnProps as `$${K}`]: ColumnProps[K];
};

export const columnStyles = css<StyledColumnProps>`
  grid-column: ${({ $columns }) => getColumnSpan($columns)};

  ${({ $columns2xl }) =>
    $columns2xl &&
    mediaQuery(
      '2xl',
      css`
        grid-column: ${getColumnSpan($columns2xl)};
      `
    )}

  ${({ $columnsXl }) =>
    $columnsXl &&
    mediaQuery(
      'xl',
      css`
        grid-column: ${getColumnSpan($columnsXl)};
      `
    )}

  ${({ $columnsLg }) =>
    $columnsLg &&
    mediaQuery(
      'lg',
      css`
        grid-column: ${getColumnSpan($columnsLg)};
      `
    )}

  ${({ $columnsMd }) =>
    $columnsMd &&
    mediaQuery(
      'md',
      css`
        grid-column: ${getColumnSpan($columnsMd)};
      `
    )}

  ${({ $columnsSm }) =>
    $columnsSm &&
    mediaQuery(
      'sm',
      css`
        grid-column: ${getColumnSpan($columnsSm)};
      `
    )}
`;
